import { tools as seedTools, notes as seedNotes } from "@/data/aitools";

// ---------- localStorage 持久化辅助 ----------
const KEY = {
  favTools: "ait_fav_tools",
  favNotes: "ait_fav_notes",
  compare: "ait_compare",
  userNotes: "ait_user_notes",
  theme: "ait_theme",
};

function load(key, fallback) {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    return fallback;
  }
}
function save(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    /* ignore quota errors */
  }
}

// ---------- 工具细节工具函数 ----------
function matchTagShare(aId, bId) {
  const a = seedTools.find((t) => t.id === aId);
  const b = seedTools.find((t) => t.id === bId);
  if (!a || !b) return 0;
  return a.tags.filter((t) => b.tags.includes(t)).length;
}

export default {
  namespaced: true,
  state() {
    return {
      theme: load(KEY.theme, "light"),
      tools: seedTools,
      collections: [], // 保留字段，合集数据引用自 data/aitools
      // 笔记 = 种子示例 + 用户本地笔记
      notes: [...seedNotes, ...load(KEY.userNotes, [])],
      // 收藏
      favToolIds: load(KEY.favTools, []),
      favNoteIds: load(KEY.favNotes, []),
      // 对比列表（限制 2-4）
      compareIds: load(KEY.compare, []),
    };
  },
  getters: {
    userNotes: (state) =>
      state.notes.filter((n) => n.id && String(n.id).startsWith("user-")),
    toolById: (state) => (id) => state.tools.find((t) => t.id === id),
    noteById: (state) => (id) => state.notes.find((n) => n.id === id),
    notesByTool: (state) => (toolId) =>
      state.notes.filter((n) => n.toolId === toolId),
    favTools: (state) =>
      state.tools.filter((t) => state.favToolIds.includes(t.id)),
    favNotes: (state) =>
      state.notes.filter((n) => state.favNoteIds.includes(n.id)),
    compareTools: (state) =>
      state.compareIds
        .map((id) => state.tools.find((t) => t.id === id))
        .filter(Boolean),
    similarTools: (state) => (toolId) =>
      state.tools
        .filter((t) => t.id !== toolId)
        .map((t) => ({ tool: t, share: matchTagShare(toolId, t.id) }))
        .sort((a, b) => b.share - a.share)
        .slice(0, 3)
        .map((x) => x.tool),
    stats: (state) => ({
      toolCount: state.tools.length,
      noteCount: state.notes.length,
      favToolCount: state.favToolIds.length,
      favNoteCount: state.favNoteIds.length,
    }),
  },
  mutations: {
    toggleTheme(state, theme) {
      state.theme = theme;
      save(KEY.theme, theme);
    },
    toggleFavTool(state, id) {
      state.favToolIds = state.favToolIds.includes(id)
        ? state.favToolIds.filter((x) => x !== id)
        : [...state.favToolIds, id];
      save(KEY.favTools, state.favToolIds);
    },
    toggleFavNote(state, id) {
      state.favNoteIds = state.favNoteIds.includes(id)
        ? state.favNoteIds.filter((x) => x !== id)
        : [...state.favNoteIds, id];
      save(KEY.favNotes, state.favNoteIds);
    },
    addCompare(state, id) {
      if (!state.compareIds.includes(id) && state.compareIds.length < 4) {
        state.compareIds = [...state.compareIds, id];
        save(KEY.compare, state.compareIds);
      }
    },
    removeCompare(state, id) {
      state.compareIds = state.compareIds.filter((x) => x !== id);
      save(KEY.compare, state.compareIds);
    },
    clearCompare(state) {
      state.compareIds = [];
      save(KEY.compare, state.compareIds);
    },
    addNote(state, note) {
      state.notes = [...state.notes, note];
      save(
        KEY.userNotes,
        state.notes.filter((n) => String(n.id).startsWith("user-"))
      );
    },
    updateNote(state, note) {
      state.notes = state.notes.map((n) => (n.id === note.id ? note : n));
      save(
        KEY.userNotes,
        state.notes.filter((n) => String(n.id).startsWith("user-"))
      );
    },
    deleteNote(state, id) {
      state.notes = state.notes.filter((n) => n.id !== id);
      state.favNoteIds = state.favNoteIds.filter((x) => x !== id);
      save(
        KEY.userNotes,
        state.notes.filter((n) => String(n.id).startsWith("user-"))
      );
      save(KEY.favNotes, state.favNoteIds);
    },
  },
};
